import React, { useState } from 'react'
import './Login.css';
import { Link, useHistory } from 'react-router-dom';
import { auth } from "./firebase";


function Login() {
    const history = useHistory()
    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');

    const signIn = e => {
        e.preventDefault();
        // firebase login
        auth
        .signInWithEmailAndPassword(email, password)
        .then(auth => {
                history.push('/')
        })
    }

    const register = e => {
        e.preventDefault();
        // firebase register
        auth
        .createUserWithEmailAndPassword(email, password)
        .then((auth) => {
            console.log(auth);
            if (auth) {
                history.push('/')
            }
        })
        .catch(error => alert(error.message))
    }

    return (
        <div className="form">
            <div className="sign">
                <h1>Sign-in</h1>

                <form>
                    <h5>Name</h5>
                    <input type="text" />

                    <h5>E-mail</h5>
                    <input type="text" value={email} onChange= {e => setEmail(e.target.value)} />

                    <h5>Password</h5>
                    <input type="password" value={password} onChange= {e => setPassword(e.target.value)} />

                    <Link to="/">
                        <button className="in" onClick={signIn} type="submit">Sign in</button>
                    </Link>
                </form>
                    <p className="conditions">By continuing, you agree to Amazon's Conditions of
                        Use and Privacy Notice.</p>
                        
                    <button className="create" onClick={register}>Create your amazon account</button>
            </div>
        </div>
    )
}

export default Login
